import React, { useContext, useEffect, useRef, useState } from 'react';
import { FormContext } from '../FormContext';
import Part from './Part';
import axios from 'axios';
import ReCAPTCHA from "react-google-recaptcha";
import QRCode from "react-qr-code";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toPng } from 'html-to-image';
import { faPrint, faQrcode, faShareFromSquare, faXmark } from '@fortawesome/free-solid-svg-icons'
import { useMediaQuery } from 'react-responsive'

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Form.css';


const Form = ({ formElements: { form_label, form_label_enable, pages, form_tab_enable, form_nav_enable, form_back } }) => {
  const { formPrintEnable, formUrl, formCaptchaEnable, formCustomEnable, customPages, pageType, formOfficer, submitId, submitTime, handleSubmit, currentPageIndex, setCurrentPageIndex, disableField, formAdmin, formApprovalIndex, formUserLock } = useContext(FormContext)
  const [disable, setDisable] = useState(false)
  const [captchaDisable, setCaptchaDisable] = useState(true)
  const [showQRcode, setShowQrcode] = useState(false)
  const [officalProgressHTML, setOfficialProgressHTML] = useState({ __html: "" });
  const [showOfficialProgress, setShowOfficialProgress] = useState(false)
  const [showCross, setShowCross] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false);

  let pagesDisplay = pageType ? pages?.filter(page => page.page_type == pageType) : pages?.filter(page => page.page_type == 'user');
  //console.log('pagesDisplay',pagesDisplay, pageType)
  const qrCodeRef = useRef(null);
  const parts = pagesDisplay ? pagesDisplay[currentPageIndex].parts : null;
  const page_description_index = pagesDisplay ? pagesDisplay[currentPageIndex].page_description_index : (pages ? pages[currentPageIndex].page_description_index : null)
  const page_user = pagesDisplay ? pagesDisplay[currentPageIndex].page_user : (pages ? pages[currentPageIndex].page_user : null)
  const page_type = pagesDisplay ? pagesDisplay[currentPageIndex].page_type : (pages ? pages[currentPageIndex].page_type : null)
  const customParts = customPages?.parts;
  //console.log('customParts',customParts )
  console.log('formPrintEnable', formPrintEnable);


  const numOfPages = pagesDisplay ? pagesDisplay.length : 0;
  const isSmallScreen = useMediaQuery({ maxWidth: 576 });

  useEffect(() => {
    if (qrCodeRef.current) {
      // Get the browser height
      const browserHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

      // Set the maximum height of the div to 50% of the browser height
      const maxHeight = browserHeight * 0.5;
      qrCodeRef.current.style.maxHeight = `${maxHeight}px`;
    }
  }, []);

  useEffect(() => {
    setCaptchaDisable(formCaptchaEnable)
  }, [formCaptchaEnable])

  useEffect(() => {
    const fetchData = async () => {
      if (showOfficialProgress) {
        try {
          const response = await axios.get(`https://eform.hsu.edu.hk/form/action/selectProgress.php?formId=${submitId}`);
          setOfficialProgressHTML({ __html: response.data.toString() });
          console.log(response.data.toString())
          // scrollToBottom();
          printPage();

        } catch (error) {
          console.error('Error fetching API:', error);
        }
      } else {
        scrollToTop();
        setOfficialProgressHTML({ __html: "" });
      }
    };

    fetchData();
  }, [showOfficialProgress]);


  const onChange = (value) => {
    if (value) {
      setCaptchaDisable(false)
    }

  }

  
  const pressSubmit = (event) => {
    if (!isSubmitting) {
      setIsSubmitting(true);
      setDisable(true);
  
      handleSubmit(event)
        .then(() => {
          // Successful submission
          setIsSubmitting(false);
          setDisable(false);
        })
        .catch((error) => {
          // Handle errors and re-enable the button
          console.error('Submission errors:', error);
          setIsSubmitting(false);
          setDisable(false);
        });
    }
  };


  const closeForm = () => {
    window.top.location.href = form_back;
  }
  const revert = () => {
    const params = new URLSearchParams();
    params.append('submitId', submitId);
    axios({
      method: 'post',
      url: `https://eform.hsu.edu.hk/form/action/revertForm.php`,
      data: params
    }).then(function (res) {

      const { redirect } = res.data
      //console.log('redirect at Form.js',res.data)
      // window.parent.location.href = `https://eform.hsu.edu.hk/form/${redirect}`;
      window.location.href = `https://eform.hsu.edu.hk/form/${redirect}?submitId=${submitId}`;

    })

  }

  const goNext = () => {
    //console.log('go next')
    let isValid = true;

    //console.log('go next parts', parts)
    parts.forEach(part => {
      const { fields } = part
      fields.forEach(field => {
        if (field.field_mandatory === "yes" && !field.field_value) {
          //console.log(field.field_id, field.field_value)
          isValid = false
          return
        }
      })
    })
    if (isValid === false) {
      alert("Please fill-in compulsory fields.")
      return;
    }
    setCurrentPageIndex(currentPageIndex + 1)


  }
  let disableSaveBtn = () => {

    // if (page_type === 'user') {
    //   return false
    // }
    return (page_type === 'official' && currentPageIndex !== formApprovalIndex - 1) || (page_type === 'user' && formUserLock) || (formOfficer !== page_user && !formAdmin)

  }



  const htmlToImageConvert = () => {
    toPng(qrCodeRef.current, { cacheBust: false })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "qrcode.png";
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  };



  let revertButton;
  // (formAdmin ) && (<button>revert</button>)
  const hasRevertBtn = () => {
    return formAdmin && page_type === 'official' && currentPageIndex === formApprovalIndex - 1 && formOfficer === page_user
  }




  (hasRevertBtn()) && (revertButton = (<button className="btn btn-danger" onClick={revert}>Revert {formApprovalIndex <= 1 && `to applicant`}</button>))

  let renderButton = currentPageIndex === (numOfPages - 1) ? ((disableField ? (!showOfficialProgress && !showQRcode && <button type="button" style={{ marginRight: 5 }} className="btn btn-success" id="btnInfo" onClick={closeForm}>Close</button>) : <>{formCaptchaEnable && <ReCAPTCHA
    sitekey="6Lf2H18jAAAAALhFY8ViQtjOwFlvrCeObBUc9-d8"
    onChange={onChange}
  />}
    <button type="button" disabled={formUserLock || disable || captchaDisable} className="btn btn-success" id="btnInfo" style={{ marginRight: 5 }} onClick={(e) => pressSubmit(e)} >Submit</button>
  </>)) : (<button type="button" className="btn btn-success" id="btnInfo" style={{ marginRight: 5 }} onClick={goNext}>Next </button>)
  formAdmin &&  (renderButton = (
    // <button type="button" style={{ marginRight: 5 }} disabled={page_type === 'official' ||disable|| formUserLock ? !hasRevertBtn() : disableSaveBtn()} className="btn btn-success hide-on-print" id="btnInfo" onClick={e => pressSubmit(e)}>{pageType == 'official' ? 'Submit 2' : 'Save'} {disable? 'disable true':'disable false'}</button>
    <button type="button" style={{ marginRight: 5 }} 
    disabled={disable ||  (formUserLock ? !hasRevertBtn() : disableSaveBtn())}
    className="btn btn-success hide-on-print" id="btnInfo" onClick={e => pressSubmit(e)}>{pageType == 'official' ? 'Submit' : 'Save'}</button>
  ))

  const printPage = () => {
    window.print()
  }


  const toggleShowCross = () => {
    setShowCross((prevState) => !prevState);
  };

  const togglePrint = async () => {
    // setShowOfficialProgress(showOfficialProgress);
    setShowOfficialProgress(true);
    setShowQrcode(false)
    setShowCross(true)
    console.log('togglePrint')
    // alert('toggleprint')

  };
  const toggleQRcode = () => {
    setShowQrcode(true);
    setShowCross(true)

  };

  const closeQrcodeOrPrint = () => {
    setShowOfficialProgress(false);
    setShowQrcode(false)
    toggleShowCross();


  }


  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  // const togglePrint = async () => {
  //   alert('togglePrint')
  // }
  const copyURL = () => {
    const currentURL = formUrl;
    var button = document.getElementById("copyButton");
    var originalText = button.innerHTML;

    navigator.clipboard.writeText(currentURL)
      .then(() => {
        // toast('URL copied')
        console.log('URL copied to clipboard');
        button.innerHTML = "URL copied";
        setTimeout(function () {
          button.innerHTML = originalText;
        }, 1000);
      })
      .catch((error) => {
        console.error('Failed to copy URL to clipboard:', error);
      });
  };

  if (!parts) {

    return (<div className="content-wrapper specious" style={{ marginTop: form_nav_enable ? 50 : 0 }}>
      <center>
        <div className="content specious text-left">
          <div className="container-fluid specious">
            <div className="row">
              <div className="col-sm-12 specious">
                <div className="text-center pt-4 pb-3"><h3> Loading...</h3>

                </div>

              </div>
            </div>
          </div>
        </div>
      </center>
    </div>
    )
  }


  return (



    <div className="content-wrapper specious" style={{ marginTop: form_nav_enable ? 50 : 0 }}>
      <center>
        <div className="content specious text-left">
          <div className="container-fluid specious">
            <div className="row">
              <div className="col-sm-12 specious">

               
                {form_label_enable && (
                  <div className="title-qrcode-container" style={{ display: 'flex', alignItems: 'center' }}>
                    {(!isSmallScreen && formUrl) && <div className="col-2"></div>}
                    <div className={formUrl ? 'col-8 text-center' : 'col-12 text-center'}>
                      <div className="text-center pt-4 pb-3">
                        <h2 className={isSmallScreen ? 'small-screen-label' : ''}>{form_label}</h2>
                      </div>
                    </div>
                    {formUrl && (
                      <>
                        <div className="col-2 text-right qr-code-print show-on-print">
                          <QRCode value={formUrl} size={64} />
                        </div>
                        <div className="col-2 text-right qr-code pt-4 pb-3 hide-on-print">
                          <div className="d-flex align-items-center justify-content-end">
                            <span className="icon-container">
                              {!showOfficialProgress && !showCross && (
                                <FontAwesomeIcon icon={faPrint} size="2x" onClick={togglePrint} />
                              )}
                              {showCross && <FontAwesomeIcon icon={faXmark} size="2x" onClick={closeQrcodeOrPrint} />}
                            </span>
                            <span className="icon-container">
                              {!showQRcode && !showCross && (
                                <FontAwesomeIcon icon={faShareFromSquare} size="2x" onClick={toggleQRcode} />
                              )}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )}



                <div className="card card-primary card-outline card-outline-tabs">
                  {form_tab_enable && <div className="card-header p-0 pt-0 border-bottom-0">
                    <ul className="nav nav-tabs">
                      {/* {(page_type === 'official') && <li className="nav-item"><a className={`nav-link`} href={`https://eform.hsu.edu.hk/form/admin/progress.php?formId=${submitId}`}  >Progress</a></li>} */}
                      {(page_type === 'official') && <li className="nav-item"><a className={`nav-link`} href={`https://eform.hsu.edu.hk/form/officer/progress.php?formId=${submitId}`}  >Progress</a></li>}
                      {/* {(page_type === 'official') && <li className="nav-item"><a className={`nav-link`} href={`https://eform.hsu.edu.hk/chat/app/?formId=${submitId}`}  >Message</a></li>} */}
                      {(page_type === 'official') && <li className="nav-item"><a className={`nav-link`} href={`https://eform.hsu.edu.hk/form/officer/message.php?formId=${submitId}`}  >Message</a></li>}
                      {/* {(page_type === 'official') && <li className="nav-item"><a className={`nav-link`} href={`https://eform.hsu.edu.hk/form/admin/message.php?formId=${submitId}`}  >Message</a></li>} */}
                      {pagesDisplay.map((page, i) => currentPageIndex === i && (
                        <li className="nav-item" key={i}>
                          <a
                            className={`nav-link ${currentPageIndex === i && "active"}`}
                            href="#page1"
                            data-toggle="tab"
                            onClick={() => setCurrentPageIndex(i)}
                          >
                            {page.page_label ? page.page_label : `Page ${i + 1}`}
                          </a>
                        </li>
                      ))}

                      {/* {pagesDisplay.map((page, i) => <li className="nav-item"><a className={`nav-link ${currentPageIndex === i && "active"}`} href="#page1" data-toggle="tab" onClick={() => setCurrentPageIndex(i)}>{page.page_label ? page.page_label : `Page ${i + 1}`}</a></li>)} */}

                    </ul>
                    {(page_type === 'user' && submitId) && <div class="card-tools pt-2">{submitId}</div>}
                  </div>}


                  <div className="card-body">
                    {formUrl && <div className="mb-4">{submitId ? 'Ref#: ' + submitId : ''}<br />{submitTime ? 'Date: ' + submitTime.split("T")[0] : ''} </div>}

                    {(showQRcode && formUrl) && <div className="card-body" style={{ marginBottom: 100 }}>

                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 25 }}> {/* Center the QRCode component */}
                        <input type="text" value={formUrl} class="form-control form-input text-center" />
                        <button className="btn btn-success mb-5" id="copyButton" onClick={copyURL}><FontAwesomeIcon icon={faShareFromSquare} size="1x" />&nbsp; Copy URL</button>
                        <div id="eform-qrcode" ref={qrCodeRef}>
                          <QRCode
                            value={formUrl}
                          // size={640}
                          />
                        </div>
                        <div className="d-flex justify-content-center">
                          <button className="btn btn-success mr-2" onClick={htmlToImageConvert}>Download Code</button>

                          {/* <ToastContainer /> */}
                          {/* <button className="btn btn-danger" onClick={()=>setShowQrcode(false)}>Close Code</button> */}
                        </div>
                      </div>

                    </div>}
                    {!showQRcode && <div className="row">
                      {parts.length > 0 && parts.map((part, i) => <Part key={i} part={part} part_id={i} page_description_index={page_description_index} page_user={page_user} page_type={page_type} />)}

                    </div>}
                  </div>
                  <div >
                    {!showQRcode && <div className="row">
                      <div className="col" style={{ display: 'flex', flexDirection: 'column' }}>
                        <div dangerouslySetInnerHTML={officalProgressHTML} />
                        {showOfficialProgress && <div className='card-body d-flex justify-content-center'>
                          <button className="btn btn-success mr-2 hide-on-print" onClick={printPage} >Print Form</button>
                          {/* <button className="btn btn-danger hide-on-print" onClick={cancelPrint}>Cancel Print</button> */}
                        </div>}
                      </div>
                    </div>}
                  </div>

                  {(page_type == 'user' && formCustomEnable) && <div className="card-body">
                    <div className="row">
                      {customParts.length > 0 && customParts.map((part, i) => <Part key={i} part={part} part_id={i} page_user={page_user} page_type={page_type} custom_at_user={true} />)}
                      
                    </div>
                  </div>}


                  <div className={`card-body ${page_type == "custom" ? 'text-left margin-custom' : 'text-center'}`}>
                    {/* <div className={`card-body ${page_type=="custom"?'text-left margin-custom':'text-center'}`} style={{marginTop:pageType=='custom'?-40:0}} > */}
                    {currentPageIndex !== 0 && !formAdmin ? <button type="button" className="btn btn-success" id="prevInfo" style={{ marginRight: 5 }} onClick={() => setCurrentPageIndex(currentPageIndex - 1)}>Previous</button> : null}


                    {(pageType === 'user' && !showQRcode && !showOfficialProgress) || pageType !== 'user' ? renderButton : null}
                    {/* {((page_type == 'user') && formStatus === 'Submitted' && formPrintEnable != false) && <a type="button" style={{ marginRight: 5 }} className="text-success pt-2 pl-2" id="btnInfo" onClick={printPage}><u>Print Form 列印表格</u></a>
                    } */}
                  </div>


                </div>
              </div>
            </div>
          </div>

        </div>
      </center>
      <div className="scrolltop-wrap">
        <a href="#" role="button" aria-label="Scroll to top">
          <svg height={48} viewBox="0 0 48 48" width={48} xmlns="http://www.w3.org/2000/svg">
            <path id="scrolltop-bg" d="M0 0h48v48h-48z" />
            <path id="scrolltop-arrow" d="M14.83 30.83l9.17-9.17 9.17 9.17 2.83-2.83-12-12-12 12z" />
          </svg>
        </a>
      </div>

    </div>


  )
}



export default Form
